var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mTooltip',{attrs:{"pagination":_vm.pagination,"enabled":_vm.disabled,"content":_vm.disabledTooltip}},[_c('button',{class:`m-button ${_vm.type} ${_vm.size} ${_vm.minimal ? 'minimal' : ''} ${
        _vm.outline ? 'outline' : ''
      } ${_vm.disabled ? 'disabled' : ''} ${_vm.hidden ? 'hidden' : ''} ${
        _vm.fullWidth ? 'full-width' : ''
      }`,on:{"click":_vm.handleOnClick}},[(_vm.iconLeft != '')?_c('i',{class:`fas ${_vm.iconLeft}`}):_vm._e(),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.iconRight != '')?_c('i',{class:`fas ${_vm.iconRight}`}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }